import { AsyncStatus } from '../types';

export const isIdle = (status: AsyncStatus) => status === AsyncStatus.IDLE;
export const isPending = (status: AsyncStatus) => status === AsyncStatus.PENDING;
export const isResolved = (status: AsyncStatus) => status === AsyncStatus.RESOLVED;
export const isRejected = (status: AsyncStatus) => status === AsyncStatus.REJECTED;
